import type { NewsListResponse } from '@swiftpay/shared';
import { apiFetch } from './client.js';

export const newsApi = {
  list: () => apiFetch<NewsListResponse>('/api/news'),
};
